/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_2Inputs */

const da_privacy_rights_2 = /** @type {(inputs: Privacy_Rights_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan klage til Datatilsynet: [datatilsynet.dk](https://www.datatilsynet.dk).`)
};

/** @type {(inputs: Privacy_Rights_2Inputs) => LocalizedString} */
const en_privacy_rights_2 = da_privacy_rights_2;

/**

* @param {Privacy_Rights_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_2 = /** @type {((inputs?: Privacy_Rights_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_rights_2(inputs)
	return /** @type {LocalizedString} */ ("Du kan klage til Datatilsynet: [datatilsynet.dk](https://www.datatilsynet.dk).")
});